const modalTitles = {
  users: "PLANS.TOO_MANY_ACTIVE_USERS"
};

class Invite {
    [x: string]: any;
 	 static $inject = ['$filter','Users','Toast','AmplitudeService', 'ModalService', 'LimitUsers', '$location'];
    constructor($filter, Users, Toast, AmplitudeService, ModalService, LimitUsers, $location) {
        this.$filter = $filter;
        this.Users = Users;
        this.toast = Toast;
        this.amplitude = AmplitudeService;
        this.ModalService = ModalService;
        this.LimitUsers = LimitUsers;
        this.$location = $location;
        this.valid = false;
    }

    $onInit() {
      this.amplitude.logEvent('Panel:Users:Invite: Init');
      this.invitation = {};
        this.maxLimitUsersPlan = this.stats.usersCount + this.stats.pendingUsersCount;
    }

    invite() {
      this.Users.invite({}, {invitations: [this.invitation]}, () => {
        this.amplitude.logEvent('Panel:Users:Invite: Sent');
        this.toast.success('USERS.INVITATION_SENT');
        this.$location.url('/users/all?newInvitation=true');
      }, (error) => {
        if (error.data.includes('USERS.LIMIT_REACHED')) {
          this.showModalChangeUserLimit();
        }
      })
    }

    get validForm() {
      return this.invitation.email && this.invitation.roleId;
    }

    getActiveUsersCount() {
      return this.users.filter((user) => (user.state === 'ACTIVE' || user.state === 'PENDING')).length;
    }

    showModalChangeUserLimit() {
      this.amplitude.logEvent("Panel:Users:Invite: Error - users limit reached");
      this.ModalService.showPlanLimitUsersModal( modalTitles.users, '', this.users, this.maxLimitUsersPlan).then((response) => {
        this.amplitude.logEvent("Panel:Users:Invite: Number of users reduced");
        this.users = this.getActiveUsersCount();
        this.LimitUsers.updateUsers(response);
        this.toast.success();
      }, () => {
        this.amplitude.logEvent("Panel:Users:Invite: Number of users not reduced");
        this.setStartCountUser();
      });
    }
}

export default {
    controller: Invite,
    template : require('./users.invite.new.html'),
    bindings: { users: '<', stats: '<' }
};
